import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../../modules/infra/i18n';
import mailchimpIcon from '../../../../../../../images/mailchimpIcon.png';
import PendingConnectionModal from '../../../../../common/PendingConnectionModal';

const MailchimpConnectionPage = ({ handleConnect, openedIsOn }) => (
  <div className="mailchimp-connection">
    <img
      alt="mailchimp-logo"
      className="mailchimp-logo"
      src={mailchimpIcon}
      role="presentation"
    />
    <h1>{t('settings:integrations.mailchimp.connection.heading')}</h1>
    <h2>{t('settings:integrations.mailchimp.connection.subheading')}</h2>
    <div className="mailchimp-connection__body">
      <p>
        {t('settings:integrations.mailchimp.connection.description_1')}
      </p>
      <p>
        {t('settings:integrations.mailchimp.connection.description_2')}
      </p>
    </div>
    <div className="mailchimp-connection__footer">
      <button
        className="c-btn c-btn--primary c-btn--medium"
        data-automation-id="connect-to-mailchimp"
        type="button"
        onClick={handleConnect}
      >
        {t('settings:integrations.mailchimp.connection.connect_button')}
      </button>
    </div>
    <PendingConnectionModal
      display-if={openedIsOn}
      text={t('settings:integrations.mailchimp.connection.pending_modal')}
    />
  </div>
);

MailchimpConnectionPage.propTypes = {
  handleConnect: PropTypes.func.isRequired,
  openedIsOn: PropTypes.bool.isRequired,
};

export default MailchimpConnectionPage;
